<!--
 * @Descripttion : 平台规则
 * @version      : 
 * @Author       : ml
 * @Date         : 2020-10-16 12:14:47
 * @LastEditors  : min
 * @LastEditTime : 2020-12-28 20:03:22
-->
<template>
  <div>
    <!-- <van-cell title="《平台服务协议》" is-link @click="goToUrl(0)" />
    <van-cell title="《平台隐私协议》" is-link @click="goToUrl(1)" />
    <van-cell title="《机构拍卖服务协议》" is-link @click="goToUrl(2)" /> -->

    <van-cell v-for="(item,index) in xieYiList" :key="index" :title="'《'+item.name+'》'" is-link @click="goToUrl(item.url)"></van-cell>
  </div>
</template>
<script>

import { InstitutionPublicConfig } from '@/request/platformRules'

export default {
  data() {
    return {
      groupID: this.$route.query.groupid || 1, //  集团ID
      //   isApp: this.$route.query.isapp    //  是否来源于APP
      xieYiList: []
    };
  },
  mounted() {
    this.InstitutionPublicConfig();
  },
  methods: {
    InstitutionPublicConfig() {
      const that = this;
      InstitutionPublicConfig({
        institutionID: that.groupID,
        sourceType: 1
      }).then(res => {
        that.xieYiList = res.data.data.xieYiList;
      })
    },
    goToUrl(url) {
      // 从 url 中提取 groupid 参数
      let groupid = '';
      if (url) {
        const match = url.match(/groupid=([^&]*)/);
        groupid = match ? match[1] : '';
      }
      // 《平台服务协议》 "http://common.carwins.cn/allianceauction/static/registrationpolicy.html?groupid=";
      if (url.indexOf('serviceAgreement') > -1) {
        this.$router.push({
          path: "/serviceAgreement",
          query: {
            groupid: groupid
          }
        });
      }
      // 《平台隐私协议》  "http://common.carwins.cn/allianceauction/static/privacypolicy.html?groupid=";
      if (url.indexOf('privacyAgreement') > -1) {
        this.$router.push({
          path: "/privacyAgreement",
          query: {
            groupid: groupid
          }
        });
      }

      // 《机构拍卖服务协议》 "http://common.carwins.cn/allianceauction/static/registrationpolicy.html?groupid=" +
      if (url.indexOf('auctionAgreement') > -1) {
        this.$router.push({
          path: "/auctionAgreement",
          query: {
            groupid: groupid
          }
        });
      }

      if (url.indexOf('businessRule') > -1) {
        this.$router.push({
          path: "/businessRule",
          query: {
            groupid: groupid
          }
        });
      }
    }
  }
};
</script>